// extracted by mini-css-extract-plugin
export var standaloneTable = "_ga-0";
export var withExtraHeader = "_ga-1";